let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ktpeh")).then(() => parcelRequire('6Zwhu'));